<template>
  <router-view />
</template>

<script setup>
import {onBeforeMount} from "vue";
const helpers = require("@/helpers/helpers.js");
const baseURL = process.env.VUE_APP_BASE_URL;

onBeforeMount(() => {
    helpers.cssFile("hubsynchCommon.css", baseURL);
});
</script>
<style lang="scss">
$color: red;
</style>